'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:SetupScheduleController
 * @description
 * # SetupScheduleController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ProfileController', ['$scope', '$rootScope', '$location', '$routeParams', '$window', '$timeout', 'ProfilePage', 'ProfileActions', 'CommonHelper', 'ProfileHelper', 'ProfileConstants', 'ListGrid', 'ListGridHelper', 'ListGridStatus', 'ListGridConstants', 'ListGridSettings', 'ListGridRowActions', 'RecurrenceModalsBridge', 'GridService', 'PreviewScheduleService', 'MainMenu', 'UserInfo', 'Animation', 'FlashService', 'Utils', 'Constants', 'ConfirmationService',
    function ($scope, $rootScope, $location, $routeParams, $window, $timeout, ProfilePage, ProfileActions, CommonHelper, ProfileHelper, ProfileConstants, ListGrid, ListGridHelper, ListGridStatus, ListGridConstants, ListGridSettings, ListGridRowActions, RecurrenceModalsBridge, GridService, PreviewScheduleService, MainMenu, UserInfo, Animation, FlashService, Utils, Constants, ConfirmationService) {

        ProfileHelper.pageId = $routeParams.grid;

        $scope.profile = new ProfilePage();

        $scope.showAllertTitle = true;

        $scope.fullScreen = { isFullScreen: false };

        var userData = null;

        UserInfo.GetUserInfo().then(function (user) {
            userData = user;
        });

        $scope.toggleFullScreen = function () {
            $scope.fullScreen.isFullScreen = !$scope.fullScreen.isFullScreen;
            if ($scope.fullScreen.isFullScreen) {
                MainMenu.HideMenu();
            } else {
                MainMenu.ShowMenu();
            }
        };

        $scope.applyQuickFilter = function () {
            var originalProfileMenuCopy = angular.copy($scope.originalProfileMenu);

            $scope.profileMenu = originalProfileMenuCopy.filter(function (menuItem) {
                if (menuItem.children) {
                    menuItem.children = menuItem.children.filter(function (childMenuItem) {
                        return (childMenuItem.label && childMenuItem.label.length && childMenuItem.label.length > 0 && ((childMenuItem.label.toLowerCase()).indexOf($scope.profile.quickFilter.toLowerCase()) !== -1)) ||
                            (childMenuItem.secondaryItem && childMenuItem.secondaryItem.length && childMenuItem.secondaryItem.length > 0 && ((childMenuItem.secondaryItem.toLowerCase()).indexOf($scope.profile.quickFilter.toLowerCase()) !== -1));
                    });

                    return menuItem.children.length > 0;
                }

                return (menuItem.label && menuItem.label.length && menuItem.label.length > 0 && ((menuItem.label.toLowerCase()).indexOf($scope.profile.quickFilter.toLowerCase()) !== -1)) ||
                    (menuItem.secondaryItem && menuItem.secondaryItem.length && menuItem.secondaryItem.length > 0 && ((menuItem.secondaryItem.toLowerCase()).indexOf($scope.profile.quickFilter.toLowerCase()) !== -1));
            });

            if ($scope.profile.quickFilter) {
                $scope.expandAllGroupingMenuItems();
            } else {
                $scope.collapseAllGroupingMenuItems();
            }
        };

        $scope.tryToSelectPageItem = function (newItem) {
            if (!isPageItemAlreadySelected(newItem)) {
                checkInfoTabPendingChanges($scope.selectPageItem, newItem);
            }
        };

        $scope.reselectPageItem = function () {
            if ($scope.profileItem && $scope.profileItem.isSelected) {
                var newProfileItem = getMenuItem($scope.profileItem.keys);

                if (!newProfileItem) {
                    $scope.profileItem = null;
                    return;
                }

                newProfileItem.profileContent = $scope.profileItem.profileContent;
                $scope.profileItem = newProfileItem;
                $scope.profileItem.isSelected = true;

                $scope.animation = new Animation();
                $scope.animation.setModel($scope.profileItem.entity);
                $scope.animation.setAnimationLevel("page");
                $scope.animation.initAnimation($scope.profile.pageAnimation);

                ProfileHelper.keyFilters = newProfileItem.keys;
                ProfileHelper.entities = newProfileItem.entity;
            }
        };

        $scope.selectPageItem = function (item) {

            if ($scope.profileContentIsChanging || $scope.tabIsChanging) { return; }

            $scope.profileContentIsChanging = true;

            if ($scope.profileItem && $scope.profileItem.isSelected) {
                $scope.profileItem.isSelected = false;
            }

            $scope.profileItem = getMenuItem(item.keys);
            $scope.profileItem.isSelected = true;

            ProfileHelper.keyFilters = item.keys;
            ProfileHelper.entities = item.entity;

            $scope.profile.getProfileData(item, $scope).then(function (content) {

                $scope.profileItem.profileContent = content;

                $scope.profileContentIsChanging = false;

                $scope.animation = new Animation();
                $scope.animation.setModel(item.entity);
                $scope.animation.setAnimationLevel("page");
                $scope.animation.initAnimation($scope.profile.pageAnimation);

                $scope.profile.profileItem = $scope.profileItem;

                $scope.selectTab(content.tabs[getNewSelectedProfilePageItemTabIndex(content.tabs[$scope.selectedProfilePageItemTabIndex]) || 0]);
            });
        };

        $scope.tryToSelectTab = function (newTab) {
            if (!isTabAlreadySelected(newTab)) {
                checkInfoTabPendingChanges($scope.selectTab, newTab);
            }
        };

        $scope.selectTab = function (tab) {

            if ($scope.tabIsChanging) { return; }

            setNewSelectedProfilePageItemTabIndex(tab);

            if ($scope.profileItem.profileContent.selectedTab) {
                $scope.profileItem.profileContent.selectedTab.isSelected = false;
            }

            $scope.profileItem.profileContent.selectedTab = tab;
            $scope.profileItem.profileContent.selectedTab.isSelected = true;
            $scope.editForm = $scope.profileItem.profileContent.tabs[0].data;

            switch (tab.type) {

                case ProfileConstants.TabTypes.PAGE:

                    if (tab.data) {
                        ListGridStatus.columns = tab.data.columns;
                    }

                    if ($scope.animation) {
                        $scope.animation.setModel(ProfileHelper.entities);
                        $scope.animation.setAnimationLevel("page");
                    }

                    break;

                case ProfileConstants.TabTypes.GRID:
                    var data = {
                        sectionId: tab.sectionId,
                        keyFilters: ProfileHelper.entities
                    };

                    $scope.grid = { showGrid: false };

                    $scope.tabIsChanging = true;

                    GridService.GetSection(data).then(function (result) {
                        if (result.success) {

                            $scope.animation.setModel(ProfileHelper.entities);
                            $scope.animation.performGridAnimation(result.data);

                            $scope.grid = new ListGrid(ListGridConstants.Types.Setup);
                            $scope.grid.gridData = $scope.grid.getGridData($scope, result.data);
                            $scope.grid.gridData.infoTabModel = $scope.profileItem.entity;

                            $scope.grid.actions.rowActions = new ListGridRowActions(undefined, $scope.profile.GetRoomPreviewAlerts);
                            $scope.grid.actions.rowActions.editedRow = null;
                            $scope.grid.actions.rowActions.callback = $scope.profile.GetRoomPreviewAlerts;

                            $scope.grid.profileCallback = $scope.profile.onSectionSave;
                            $scope.grid.selectedProfileMenuItem = $scope.profileItem;

                            tab.data = $scope.grid.gridData;

                            $timeout(function () { $scope.grid.showGrid = true; }, 10);

                            $scope.tabIsChanging = false;
                        }
                    });

                    break;

                case ProfileConstants.TabTypes.ROOMPREVIEW:
                    $scope.roomPreviewData = null;
                    $scope.showRoomPreview = false;

                    PreviewScheduleService.GetRoomPreview(ProfileHelper.keyFilters).then(function (result) {

                        if (result.success) {
                            $scope.roomPreviewData = $scope.profile.processRoomPreviewData(result.data);
                        }

                        $scope.showRoomPreview = true;
                    });

                    break;
            }
        };

        $scope.addNew = function () {

            var loading = FlashService.Loading();

            var retainValues = null;
            
            if ($scope.profileItem && $scope.profileItem.isSelected) {
                retainValues = getRetainValues($scope.profileItem.profileContent.tabs[0].data.formData.generalPageSection);

                $scope.profileItem.isSelected = false;
            }

            $scope.profileItem = { label: 'Adding new ...' };

            $scope.profile.alerts = [];

            $scope.profile.getAddNewPageData().then(function (page) {

                $scope.profileItem.profileContent = page;

                if (retainValues) {
                    processRetainValues($scope.profileItem.profileContent.tabs[0].data.formData.generalPageSection, retainValues);
                }

                $scope.selectTab(page.tabs[0]);

                loading.dismiss();
            });
        };

        $scope.tryToRefreshMenu = function () {
            checkInfoTabPendingChanges($scope.refreshMenu);
        };

        $scope.refreshMenu = function (item) {

            $scope.profileMenuIsChanging = true;

            $scope.profile.getProfileMenu($scope.profilePage.filters).then(function (menu) {

                var oldMenu = $scope.profileMenu;
                $scope.profileMenu = menu;
                $scope.originalProfileMenu = angular.copy(menu);
                $scope.applyQuickFilter();

                $scope.expandGroupingMenuItems(oldMenu);

                if (item && $scope.editForm.action === 0) {
                    $scope.selectPageItem(getMenuItem(item));
                }
                else {
                    $scope.reselectPageItem();
                }

                $scope.expandGroupingContainingItem();
                
                $scope.profileMenuIsChanging = false;
            });
        };

        $scope.saveData = function (changeLocationPath, callback, newItem) {
            $scope.editForm.SaveData().then(function (result) {
                if (result.success) {
                    if (changeLocationPath) {
                        $window.location.href = changeLocationPath;
                    } else if (callback) {
                        $scope.profileMenuIsChanging = true;

                        $scope.profile.getProfileMenu($scope.profilePage.filters).then(function (menu) {
                            var oldMenu = $scope.profileMenu;
                            $scope.profileMenu = menu;
                            $scope.originalProfileMenu = angular.copy(menu);
                            $scope.applyQuickFilter();
                            $scope.profileMenuIsChanging = false;
                            $scope.expandGroupingMenuItems(oldMenu);
                            callback(newItem);
                            $scope.expandGroupingContainingItem();
                            $scope.profile.GetRoomPreviewAlerts();
                        });
                    } else {
                        $scope.profile.quickFilter = '';
                        $scope.profile.profileFilters.clearAllFilters();
                        $scope.collapseAllGroupingMenuItems();
                        $scope.refreshMenu(result.data.data);
                        $scope.profile.GetRoomPreviewAlerts();
                    }
                }
            });
        };

        $scope.delete = function () {

            var loading = FlashService.Loading();

            $scope.profile.deletePage($scope.profileItem).then(function (result) {

                if (result.success) {

                    $scope.profileItem = null;
                    
                    $scope.refreshMenu();

                    if (result.message)
                    {
                        FlashService.Success(result.message);
                    }
                    
                }

                loading.dismiss();
            });
        };

        $scope.getTabCount = function (tab) {
            return tab.data ? tab.data.gridOptions.data.length : tab.counts;
        };

        $scope.expandGroupingMenuItems = function (oldMenu) {
            var expandedMenuItems = oldMenu.filter(function (item) { return item.expanded; });
            for (var i = 0; i < $scope.profileMenu.length; i++) {
                for (var j = 0; j < expandedMenuItems.length; j++) {
                    if ($scope.profileMenu[i].label === expandedMenuItems[j].label) {
                        $scope.profileMenu[i].expanded = true;
                    }
                }
            }
        };

        $scope.expandGroupingContainingItem = function () {
            for (var i = 0; i < $scope.profileMenu.length; i++) {
                if ($scope.hasProfileMenuItemGroupSelectedChildItem($scope.profileMenu[i])) {
                    $scope.profileMenu[i].expanded = true;
                }
            }
        };

        $scope.showTabCount = function (tab) {
            return tab.type === ProfileConstants.TabTypes.GRID;
        };

        $scope.tryToClearProfileItem = function () {
            checkInfoTabPendingChanges($scope.clearProfileItem);
        };

        $scope.clearProfileItem = function () {
            if ($scope.fullScreen.isFullScreen) {
                $scope.toggleFullScreen();
            }
            $scope.profileItem.isSelected = false;
            $scope.profileItem = null;
        };

        $scope.tryToApplyFilters = function () {
            checkInfoTabPendingChanges($scope.applyFilters);
        };

        $scope.applyFilters = function () {

            if ($scope.profileItem) {
                $scope.profileItem.isSelected = false;
                $scope.profileItem = null;
            }

            $scope.profileMenuIsChanging = true;

            $scope.profile.getProfileMenu($scope.profilePage.filters).then(function (menu) {
                var oldMenu = $scope.profileMenu;
                $scope.profileMenu = menu;
                $scope.originalProfileMenu = angular.copy(menu);
                $scope.applyQuickFilter();
                $scope.areThereGroupingMenuItems = areThereGroupingMenuItems($scope.profileMenu);
                $scope.expandGroupingMenuItems(oldMenu);

                $scope.profileMenuIsChanging = false;
            });

            $scope.profile.showFilterDialog = !$scope.profile.showFilterDialog;
        };

        $scope.onFiltersDialogCloseXClicked = function () {
            if (!$scope.profile.profileFilters.areFiltersPristine) {
                $scope.profile.profileFilters.onFiltersDialogCloseXClicked($scope.tryToApplyFilters);
            } else {
                $scope.profile.showFilterDialog = !$scope.profile.showFilterDialog;
            }
        };

        $scope.expandAllGroupingMenuItems = function () {
            for (var i = 0; i < $scope.profileMenu.length; i++) {
                $scope.profileMenu[i].expanded = true;
            }
        };

        $scope.collapseAllGroupingMenuItems = function () {
            for (var i = 0; i < $scope.profileMenu.length; i++) {
                $scope.profileMenu[i].expanded = false;
            }
        };

        $scope.hasProfileMenuItemGroupSelectedChildItem = function (profileMenuGroupItem) {
            if (profileMenuGroupItem.grouping) {
                return (profileMenuGroupItem.children.filter(function (childItem) { return childItem.isSelected; })).length > 0;
            }

            return false;
        };

        $scope.expandAllRoomPreviewGroupingItems = function () {
            if ($scope.roomPreviewData && $scope.roomPreviewData.activityGroups) {
                $scope.roomPreviewData.activityGroups.forEach(function (groupItem) {
                    groupItem.isExpanded = true;
                });
            }
        };

        $scope.collapseAllRoomPreviewGroupingItems = function () {
            if ($scope.roomPreviewData && $scope.roomPreviewData.activityGroups) {
                $scope.roomPreviewData.activityGroups.forEach(function (groupItem) {
                    groupItem.isExpanded = false;
                });
            }
        };

        $scope.getTotalTimeForDayOfTheWeekAllActivities = function (weekNumber, dayOfTheWeek) {
            var totalTimeForDayOfTheWeekAllActivities = 0;

            if ($scope.roomPreviewData && $scope.roomPreviewData.activityGroups) {
                $scope.roomPreviewData.activityGroups.forEach(function (groupItem) {
                    groupItem.activities.forEach(function (activity) {
                        if (activity.formattedScheduleItems[weekNumber][dayOfTheWeek] && activity.activityTypeId !== Constants.ActivityTypes.QCCheck) {
                            totalTimeForDayOfTheWeekAllActivities += activity.formattedScheduleItems[weekNumber][dayOfTheWeek];
                        }
                    });
                });
            }

            totalTimeForDayOfTheWeekAllActivities = totalTimeForDayOfTheWeekAllActivities ? Math.round(totalTimeForDayOfTheWeekAllActivities) : totalTimeForDayOfTheWeekAllActivities;

            return totalTimeForDayOfTheWeekAllActivities;
        };

        $scope.getTotalTimeForDayOfTheWeekNonDailyActivities = function (weekNumber, dayOfTheWeek) {
            var totalTimeForDayOfTheWeekNonDailyActivities = 0;

            if ($scope.roomPreviewData && $scope.roomPreviewData.activityGroups) {
                $scope.roomPreviewData.activityGroups.forEach(function (groupItem) {
                    groupItem.activities.forEach(function (activity) {
                        if (activity.recurrencePattern !== 'Daily' && activity.formattedScheduleItems[weekNumber][dayOfTheWeek] && activity.activityTypeId !== Constants.ActivityTypes.QCCheck) {
                            totalTimeForDayOfTheWeekNonDailyActivities += activity.formattedScheduleItems[weekNumber][dayOfTheWeek];
                        }
                    });
                });
            }

            totalTimeForDayOfTheWeekNonDailyActivities = totalTimeForDayOfTheWeekNonDailyActivities ? Math.round(totalTimeForDayOfTheWeekNonDailyActivities) : totalTimeForDayOfTheWeekNonDailyActivities;

            return totalTimeForDayOfTheWeekNonDailyActivities;
        };

        $scope.toggleProfileAlerts = function () {
            $scope.showAllertTitle = !$scope.showAllertTitle;
        };

        $scope.startAction = function (button) {
            var profileActions = new ProfileActions();
            var data = prepareDataForProfileAction();

            var callback = null;

            if (button.buttonType === 'SWITCH_ROOM') {
                callback = function () {
                    $scope.selectTab($scope.profileItem.profileContent.selectedTab);
                    $scope.profile.GetRoomPreviewAlerts();
                };
            }
            
            profileActions.callback = $scope.profile.GetRoomPreviewAlerts();

            profileActions.runAction(button, data, null, callback);
        };

        $scope.openRecurrence = function (activityObject) {
            var modalsBridge = new RecurrenceModalsBridge();
        
            var recurrenceData = {};
            var recurrenceModel = {};
            var entityRow = {};

            var compareExpandedStatuses = function (oldRoomPreviewData, newRoomPreviewData) {
                
                newRoomPreviewData.activityGroups.forEach(function (groupItem) {
                    var oldGroupItem = oldRoomPreviewData.activityGroups.filter(function (oldGroupItem) { return groupItem.groupName === oldGroupItem.groupName; })[0];

                    if (oldGroupItem) {
                        groupItem.isExpanded = oldGroupItem.isExpanded;
                    }
                });
            };

            var reloadPreviewOnRecurrenceUpdate = function () {
                var oldRoomPreviewData = angular.copy($scope.roomPreviewData);

                $scope.roomPreviewData = null;
                $scope.showRoomPreview = false;

                PreviewScheduleService.GetRoomPreview(ProfileHelper.keyFilters).then(function (result) {

                    if (result.success) {
                        $scope.roomPreviewData = $scope.profile.processRoomPreviewData(result.data);

                        compareExpandedStatuses(oldRoomPreviewData, $scope.roomPreviewData);
                    }

                    $scope.showRoomPreview = true;
                });
            };

            var callback = function () {
                reloadPreviewOnRecurrenceUpdate();
            };
        
            if (activityObject.recurrenceDialogData) {
                recurrenceData.PK_RSRMACT = activityObject.recurrenceDialogData.pK_RSRMACT;
                recurrenceData.ACT_DSC = activityObject.recurrenceDialogData.acT_DSC;
                recurrenceData.NM_RECSHR = activityObject.recurrenceDialogData.nM_RECSHR;
                recurrenceData.PK_RECURR = activityObject.recurrenceDialogData.pK_RECURR;
                recurrenceData.PK_RECSHR = activityObject.recurrenceDialogData.pK_RECSHR;
            }

            modalsBridge.openRecurrenceDialog(recurrenceData, recurrenceModel, entityRow, callback);
        };

        $scope.arePageInfoSectionFieldsDisabled = function () {
            var staffPageSectionIdToDisable = ProfileConstants.DisableFieldsInStaffSection.StaffPageSectionId;
            var StaffInfoTabSectionIdToDisable = ProfileConstants.DisableFieldsInStaffSection.StaffInfoTabSectionId;
            
            return CommonHelper.IsCayuseOneLogin(userData) && ($routeParams.grid === staffPageSectionIdToDisable || $scope.profileItem.profileContent.tabs[0].sectionId === StaffInfoTabSectionIdToDisable);
        }

        function processRetainValues(sections, retainValuesModel) {
            if (retainValuesModel) {
                sections.forEach(function (section) {
                    section.sectionAttributes.forEach(function (column) {
                        if (retainValuesModel[column.fieldName]) {
                            section.model[column.fieldName] = retainValuesModel[column.fieldName];
                        }
                    });
                });
            }
        }

        function getRetainValues(sections) {
            var retainModel = {};

            sections.forEach(function (section) {

                section.sectionAttributes.forEach(function (column) {

                    if (retainModel[column.fieldName] === undefined) {
                        retainModel[column.fieldName] = column.type === 'CHECKBOX' ? false : null;
                    }

                    if (column.retainSaveAddNew) {
                        retainModel[column.fieldName] = section.model[column.fieldName];

                        if (column.propertyObj.fields) {

                            column.propertyObj.fields.forEach(function (field) {

                                var childColumn = ListGridHelper.getColumnByFieldName(field);

                                if (childColumn) {
                                    retainModel[childColumn.fieldName] = section.model[childColumn.fieldName];
                                }
                            });
                        }
                    }
                });
            });

            return retainModel;
        }

        function prepareDataForProfileAction() {
            var data = {};
            data.model = {};

            if ($scope.editForm && $scope.editForm.formData && $scope.editForm.formData.model) {
                data.model = $scope.editForm.formData.model;
            }

            return data;
        }

        function getNewSelectedProfilePageItemTabIndex(newTab) {
            var showAccordingToTabAnimationBool = $scope.animation ? $scope.animation.performTabAnimation(newTab.sectionId) : undefined;

            if (showAccordingToTabAnimationBool) {

                for (var i = 0; i < $scope.profileItem.profileContent.tabs.length; i++) {
                    if ($scope.profileItem.profileContent.tabs[i].sectionId === newTab.sectionId) {
                        return i;
                    }
                }
            } else {
                return 0;
            }

            return 0;
        }

        function setNewSelectedProfilePageItemTabIndex(newTab) {
            for (var i = 0; i < $scope.profileItem.profileContent.tabs.length; i++) {
                if ($scope.profileItem.profileContent.tabs[i].sectionId === newTab.sectionId) {
                    $scope.selectedProfilePageItemTabIndex = i;

                    return;
                }
            }
        }

        function isPageItemAlreadySelected(pageItem) {
            return $scope.profileItem === pageItem;
        }

        function isTabAlreadySelected(tab) {
            return tab.isSelected;
        }

        function checkInfoTabPendingChanges(callback, newItem, event, newUrl) {

            if ($scope.editForm && $scope.editForm.form && $scope.editForm.form.$dirty || $scope.grid && $scope.grid.inlineDataChanged) {
                if (event) {
                    event.preventDefault();
                }

                var modal = Utils.OpenModal('Save pending changes?', 'ng1/src/common/confirmationModal.html', 'ModalController');

                modal.result.then(function (leave) {
                    if (leave === 'no') {
                        if ($scope.editForm && $scope.editForm.form && $scope.editForm.form.$dirty) {
                            $scope.editForm.Cancel();
                        }

                        if ($scope.grid && $scope.grid.inlineDataChanged) {
                            $scope.grid.cancel();
                        }

                        if (newUrl) {
                            $window.location.href = newUrl;
                        }

                        if (callback) {
                            callback(newItem);
                        }



                    } else if (leave === 'yes') {
                        if ($scope.editForm && $scope.editForm.form && $scope.editForm.form.$dirty) {
                            if (!$scope.editForm.form.$valid) {
                                FlashService.Error('Please, fill all required fields', true);
                            } else {

                                if (newUrl) {
                                    $scope.saveData(newUrl);
                                }

                                if (callback) {
                                    $scope.saveData(null, callback, newItem);
                                }
                            }
                        }

                        if ($scope.grid && $scope.grid.inlineDataChanged) {
                            $scope.grid.save(false, newUrl, callback, newItem);
                        }
                    }
                });
            } else if ($scope.grid && $scope.grid.actions &&
                $scope.grid.actions.rowActions.editedRow &&
                ($scope.grid.actions.rowActions.editedRow.editRecord ||
                $scope.grid.actions.rowActions.editedRow.addRecord)) {

                $scope.grid.cancel();
                callback(newItem);
            } else if (callback) {
                callback(newItem);
            }
        }

        function isAnyActionPresentInDropdown() {
            if ($scope.profilePage && $scope.profilePage.canDelete) {
                return true;
            }

            return false;
        }

        function areThereGroupingMenuItems(menuItemsArray) {
            if (menuItemsArray && menuItemsArray.length && menuItemsArray.length > 0) {
                return menuItemsArray[0].grouping;
            }

            return false;
        }

        function compareMenuItems(menuItem, item) {
            var equal = true;

            Object.keys(menuItem.keys).forEach(function (key) {
                if (menuItem.keys[key] !== item[key]) {
                    equal = false;
                }
            });

            return equal;
        }

        function getMenuItem(item) {

            var selectedItem = null;

            $scope.profileMenu.forEach(function (menuItem) {

                if (menuItem.children) {

                    menuItem.children.forEach(function (child) {

                        if (compareMenuItems(child, item)) {
                            selectedItem = child;
                        }
                    });
                } else {
                    if (compareMenuItems(menuItem, item)) {
                        selectedItem = menuItem;
                    }
                }
            });

            return selectedItem;
        }

        function processPageItemButtons(profilePageButtons) {
            $scope.pageItemButtons = {};
            $scope.pageItemButtons.visibleButtons = profilePageButtons.filter(function (pageButton) { return pageButton.alwaysVisible; });
            $scope.pageItemButtons.dropdownButtons = profilePageButtons.filter(function (pageButton) { return !pageButton.alwaysVisible; });
        }

        function loadData() {

            FlashService.ShowProgressBar();

            $scope.profile.getProfilePage().then(function (page) {
                $scope.profilePage = page;

                $scope.showActionsDropdown = isAnyActionPresentInDropdown();
                processPageItemButtons($scope.profilePage.buttons);

                FlashService.HideProgressBar();
            });

            $scope.profile.getProfileMenu().then(function (menu) {
                $scope.profileMenu = menu;
                $scope.originalProfileMenu = angular.copy($scope.profileMenu);
                $scope.profile.quickFilter = '';
                $timeout(function () {
                    var quickFilterInput = document.getElementById('quickFilterInput');

                    if (quickFilterInput) {
                        quickFilterInput.focus();
                    }
                });
                $scope.areThereGroupingMenuItems = areThereGroupingMenuItems($scope.profileMenu);
                $scope.selectedProfilePageItemTabIndex = 0;

                var params = {};
                Object.keys($routeParams).forEach(function (key) {

                    if ($routeParams[key] && key !== "grid" && key !== "id") {
                        
                        if (key === "PK_AREAS" || key === "PERS_ID") {
                            params[key] = +$routeParams[key];
                        }
                        else {
                            params[key] = $routeParams[key];
                        }
                    
                        $location.search(key, null);
                    }
                });

                if (getMenuItem(params)) {
                    $scope.selectPageItem(getMenuItem(params));
                    $scope.expandGroupingContainingItem();
                }
            });
        }

        loadData();

        angular.element($window).bind('resize', function () {
            $scope.isInstructionsOverflowed = ListGridHelper.hasContentMoreThenOneLine($scope.instructions, '100%');
        });

        $scope.$on('$locationChangeStart', function (event, newUrl) {
            checkInfoTabPendingChanges(null, null, event, newUrl);
        });

        window.addEventListener("beforeunload", function (e) {
            if ($scope.editForm && $scope.editForm.form && $scope.editForm.form.$dirty || $scope.grid && $scope.grid.inlineDataChanged) {
                var confirmationMessage = "";
                (e || window.event).returnValue = confirmationMessage;
                return confirmationMessage;
            }
        });
    }]);
